var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7402 11.07C21.6902 10.56 21.2602 10.18 20.7502 10.18H13.2002C12.6502 10.18 12.2002 10.63 12.2002 11.18V12.89C12.2002 13.44 12.6502 13.89 13.2002 13.89H17.7102C17.6002 14.81 17.0002 16.2 15.6702 17.13C14.8202 17.72 13.6902 18.13 12.2002 18.13C12.1302 18.13 12.0702 18.13 12.0002 18.12C9.4502 18.04 7.2902 16.33 6.5102 13.98C6.3002 13.35 6.1802 12.69 6.1802 12C6.1802 11.31 6.3002 10.64 6.5002 10.02C6.5602 9.83999 6.6302 9.66001 6.7102 9.48001C7.6302 7.41001 9.6402 5.95 12.0002 5.88C12.0602 5.87 12.1302 5.87 12.2002 5.87C13.6302 5.87 14.7002 6.33999 15.4502 6.85999C15.8402 7.12999 16.3602 7.06999 16.7002 6.73999L18.0902 5.38C18.5302 4.95 18.4902 4.21999 17.9902 3.85999C16.4002 2.68999 14.4602 2 12.2002 2C12.1302 2 12.0702 2.00001 12.0002 2.01001C8.1702 2.08001 4.8802 4.30001 3.2702 7.51001C2.5902 8.87001 2.2002 10.39 2.2002 12C2.2002 13.61 2.5902 15.13 3.2702 16.49H3.2802C4.8902 19.7 8.1802 21.92 12.0002 21.99C12.0702 22 12.1302 22 12.2002 22C14.9002 22 17.1702 21.11 18.8202 19.58C20.7102 17.83 21.8002 15.27 21.8002 12.22C21.8002 11.79 21.7802 11.42 21.7402 11.07Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3b9cd136fd35680ab2a1184e6656c9cf.svg";
export { ForwardRef as ReactComponent };